export function pluck (obj, path) {
  if (typeof path === 'string') {
    path = path.split('.');
  } else if (!path instanceof Array) {
    throw new Error("Invalid argument path - must be an array or string");
  }

  return path.reduce((val, prop) => {
    if (typeof val === 'object' && prop in val) {
      return val[prop];
    }
    return undefined;
  }, obj);
}
